import { AuthStorageDatasource } from '../data/datasources/auth-storage.datasource';
import { AuthApiDatasource } from '../data/datasources/auth-api.datasource';
import { AuthRepositoryImpl } from '../data/repositories/auth.repository.impl';

const storageDatasource = new AuthStorageDatasource();
const apiDatasource = new AuthApiDatasource();
const repository = new AuthRepositoryImpl(storageDatasource, apiDatasource);

export const authContainer = { repository };
